import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-statistics-view',
  templateUrl: './statistics-view.component.html',
  styleUrls: ['./statistics-view.component.scss']
})
export class StatisticsViewComponent implements OnInit {

  @Input() loading = false;
  @Input() title: string | Array<string> = null;

  constructor() { }

  ngOnInit(): void {
  }

}
